import { useTranslation } from "react-i18next";
import { NeuInput } from "../../components/neu/Neu";
import { UnitLabel } from "./UnitLabel";
import { unitOf } from "./pricingUnits";

// صف شريحة تسعير فحص الحيوية — الوحدات: عدد الفحوص/الشهر · العملة/فحص.
export const LivenessTierRow = ({ tier, index, onChange, currency = "USD" }) => {
  const { t } = useTranslation();
  return (
    <div className="grid gap-2 sm:grid-cols-2" data-testid={`liveness-tier-${index}`}>
      <div>
        <UnitLabel text={t("tokens.upToChecks")} unit={unitOf("check_month", currency, t)} />
        <NeuInput data-testid={`liveness-tier-checks-${index}`} type="number"
                  value={tier.up_to_checks ?? ""} placeholder={t("tokens.unlimited")}
                  onChange={(e) => onChange(index, "up_to_checks", e.target.value ? Number(e.target.value) : null)} />
      </div>
      <div>
        <UnitLabel text={t("tokens.costPerCheck")} unit={unitOf("per_check", currency, t)} />
        <NeuInput data-testid={`liveness-tier-cost-${index}`} type="number" step="0.0001"
                  value={tier.cost_per_check}
                  onChange={(e) => onChange(index, "cost_per_check", Number(e.target.value))} />
      </div>
    </div>
  );
};
